<template>
<div class="article-page special-page special-marugame-page">
<nav class="global-nav" role="navigation">
  <ul>
    <li>
      <router-link class="button dayrace-button" :to="{name:'Index'}">トップ</router-link>
    </li>
    <li>
      <router-link class="button dayrace-button" :to="{name:'DayRaceList',params:{date:today_str}}">本日のレース</router-link>
    </li>
  </ul>
</nav>
<nav class="bread-nav" aria-label="You are here:" role="navigation">
  <ul class="breadcrumbs">
    <li><router-link :to="{name:'Index'}">ホーム</router-link></li>
    <li>
      <span class="show-for-sr">Current: </span> 特集: {{ title }}
    </li>
  </ul>
</nav>
<div class="hero-section">
  <div class="hero-title">
  36th レディースチャンピオン
  GI LADIES CHAMPIONSHIP
  2022/8/2 - 7 (ナイター開催)
  </div>
</div>
<div class="article-container">
<div class="article-wrapper" v-html="content"></div>
<div style="text-align:center;margin:40px auto;">
<Adsense
    class="adsbygoogle"
    data-ad-client="ca-pub-3076785709839281"
    data-ad-slot="9132319872"
    data-ad-format="rectangle"
    data-full-width-responsive="true">
</Adsense>
</div>
</div>
</div>
</template>
<script>
import pianoSend from '../mixins/PrefsMixin'
export default {
  name :'SpeciaMarugame',
  mixins: [pianoSend],
  data:function(){
    return {
      date:'',
      title:'',
      content:'',
      today:'',
      today_str:'',
      id:''
    }
  },
   head:function(){
    return {
      title: function(){
        return {
          inner:  this.$data.title + ' - 36th レディースチャンピオン GI LADIES CHAMPIONSHIP',
          separator: ' - ',
          complement: 'BOATNAVI報知'
        }
      }
    }
  },
  created(){
      this.$data.id = this.$route.params['id'];
      this.getData();

      this.$data.today = new Date();
      this.$data.today_str = '' + this.$data.today.getFullYear() + ('0'+(this.$data.today.getMonth()+1)).slice(-2) + ('0'+this.$data.today.getDate()).slice(-2);
  
  },
  beforeRouteUpdate(_to, _from, _next) {
      
        if(_to.name == 'SpecialMarugame' && _from.name == 'SpecialMarugame'){
            this.$data.id =  _to.params['id'];
            this.getData();
        }

      _next();
  },
  methods:{
     getData(){
        let loader = this.$loading.show({});
        let ts = Math.floor(Number(Date.now())/1000/60);
        this.axios.get('/special_contents/marugame/'+this.$data.id+'.html?ts='+ts)
          .then((response) => {
             loader.hide();
            this.$data.content = response.data;

            let content_dom = document.createElement('div');
            content_dom.innerHTML = this.$data.content;
            this.$data.title = content_dom.getElementsByTagName('h1')[0].innerText;

            this.$emit('updateHead');
            this.pianoSend('記事',this.$data.title);
       
          })
          .catch((e) => { // eslint-disable-line
           
             loader.hide();
            this.$router.replace({ name:'NotFound'});
          });
     }
  }
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@900&display=swap&text=舟券ソムリエ～3万円コース～地元記者の目ピットマンの推奨板東宏明李風堂々1万円作戦  ');
// 舟券ソムリエ～3万円コース～
// 地元記者の目
// ピットマンの推奨舟券
// 板東宏明 李風堂々 1万円作戦

.special-marugame-page{
    .hero-section{

      background-image:linear-gradient(0deg,#ef5f9e 0%, #f47ca4 16.26%, #f4ece6 66.5%, #e15f5f 100%),url(/special_contents/assets/images/marugame/bg_hero.jpg);
      background-blend-mode: overlay,normal;
      background-position: left top,center center;
      margin-top:-10px;
      min-height:140px;
          justify-content: flex-start;
                 @media screen and (max-width:428px) {
                justify-content: center;
                position: relative;
                height:140px;
                 background-position: left top,center top;

 
             }
       .hero-title{
          background-image:url(/special_contents/assets/images/marugame/title_wide.png);
          width:860px;
          height:75%;
          min-height:100px;
          background-position: center center;
          background-repeat: no-repeat;
          background-size: contain;
          overflow: hidden;
          text-indent: -9999px;
          margin-left:20px;
          margin-top:-35px;
  

             @media screen and (max-width:428px) {
              background-image:url(/special_contents/assets/images/marugame/title_mobile.png);
                width:100%;
                height:160px;
                margin-top:5px;
                margin-left:-10px;
             }
          
        }
      
    }


  .article-container{
    // background-image:url(/special_contents/assets/images/biwako/bg1.svg),url(/special_contents/assets/images/biwako/bg1.svg) ,url(/special_contents/assets/images/biwako/bg2.svg) ;
    // background-repeat: no-repeat,no-repeat,no-repeat;
    // background-size:40%,30%,30%;
    // background-position:right -10px,right 300px,left 600px;
    max-width: 1280px;
    overflow-x:hidden;
    
      .article-wrapper{
      max-width:800px;
        .article-header{
              background-image:url(/special_contents/assets/images/marugame/bg_article_title.svg);
              padding-bottom:55px;
              position: relative;
             
              &::after{
                display:block;
                content:'.';
                width:350px;
                height:350px;
                overflow: hidden;
                text-indent: -99999px;
                position: absolute;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: contain;
                top:-20px;
                right:-240px;
                z-index:-1;
                background-image:url(/special_contents/assets/images/marugame/flower2.png);
                @media screen and (max-width:428px) {
                 width:180px;
                 height:180px;
                 top:auto;
                 right:-10px;
                 bottom:-100px;
                 opacity: 0.4;
                }
              }

            @media screen and (max-width:428px) {
              margin-left:10px;
              margin-right:10px;
              padding-left:0;
              padding-right:0;
              padding-bottom:20px;
            
                background-image:url(/special_contents/assets/images/marugame/bg_article_title.svg);
                background-size: contain;
                background-position:left bottom;

              h1{
                  line-height: 1.6;
              } 
              
      
            } 
        }



        .article-body{
            padding:20px 10px;
            clear:both;
        }


        p{
            font-size:16px;
              @media screen and (max-width:428px) { 
              font-size:14px;
            }
        }

        .image-grid{
          display:grid;
           grid-template-columns: 1fr 1fr 1fr;
           grid-gap: 10px;
           margin:30px 0 30px 0;
           @media screen and (max-width:428px) {
           grid-template-columns: 1fr 1fr;
            background-image:url(/special_contents/assets/images/marugame/flower2.png);
            background-color:rgba(255,255,255,0.8);
            background-blend-mode:lighten;
            background-size:80%;
            background-repeat: no-repeat;
            background-position: right -10px bottom 10px;
           }
           &.grid2{
              grid-template-columns: 1fr 1fr;
           }
          .image-wrapper{
            margin:0;
            
            figure{
              
              background-color:#f7feff;
              position: relative;
             img{
               max-height:300px;
             }
       
              
            }
          }
        
        }

        .lead{
            p{
              font-weight:bold;
            }
        }

        .r-yoso{
          margin-top:40px;
          clear:both;
          position: relative;
                       &::after{
                display:block;
                content:'.';
                width:250px;
                height:250px;
                overflow: hidden;
                text-indent: -99999px;
                position: absolute;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: contain;
                top:-50px;
                left:-220px;
                z-index: -1;
                background-image:url(/special_contents/assets/images/marugame/flower2.png);
                             @media screen and (max-width:428px) {
                               display: none;
             }
              }
          &__title{
            border-bottom:2px solid #e0386d;
            padding-bottom:10px;
            font-size:21px;
            font-weight: bold;
            color: #8d1438;
            background-image: url(/special_contents/assets/images/marugame/icon_boat.svg);
            background-position: left center;
            background-repeat: no-repeat;
            padding-left:80px;
             margin-bottom:20px;
              @media screen and (max-width:428px) {
                background-size:46px;
                 padding-left:50px;
                 font-size:18px;
              }
          }
          
        }

        .pit-meian{
          position: relative;
          clear:both;
          margin-top:50px;
          @media screen and (max-width:428px) {
            margin-top:80px;        
          }
          &__title{
               overflow: hidden;
               background-image: url(/special_contents/assets/images/biwako/title_pit.svg),url(/special_contents/assets/images/biwako/icon_meian.svg);
               background-repeat: no-repeat,no-repeat;
               background-position: left bottom 10px,left 150px bottom 10px;
               height:80px;
               text-indent: -9999px;
              border-bottom:2px solid #e0386d;
              padding-bottom:10px;
              margin-bottom:20px;
              
          }
        &::after{
                display:block;
                content:'.';
                width:300px;
                height:300px;
                overflow: hidden;
                text-indent: -99999px;
                position: absolute;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: contain;
                top:-40px;
                left:-265px;
                z-index:-1;
                background-image:url(/special_contents/assets/images/marugame/flower2.png);
                @media screen and (max-width:428px) {
                  right:0;
                  left: auto;
                  top:-50px;
                  width:200px;
                  height:200px;
                  opacity: 0.5;
                }
              }
        }

        .blog-funaken{
          clear:both;
          border:2px solid #fbc8c8;
          padding:20px 30px 30px 30px;
          margin-top:40px;

          background-image:url(/special_contents/assets/images/marugame/bg_funaken.svg);
          background-position: center bottom 20px;
          background-repeat: no-repeat;
          @media screen and (max-width:428px) {
             padding:30px 10px 20px 10px;
          }

          &__title{
              font-family: 'Noto Serif JP', serif;
              font-feature-settings: "palt" 1;
              font-weight:900;
              overflow: hidden;
              background-image: url(/special_contents/assets/images/marugame/icon_yen.svg);
              background-repeat: no-repeat;
              background-position: left center;
              min-height:60px;
              line-height: 1.7;
              padding-left:60px;
              padding-top:5px;

              margin-bottom:30px;
              @media screen and (max-width:428px) {
              background-image: url(/special_contents/assets/images/marugame/icon_yen.svg);
               background-size:40px;
               padding-left:45px;
               min-height:40px;
               background-position: left center;
              }
          }
        }
      }
      .boatnavi-link{
        margin-top:60px;
                &__title{
            border-bottom:2px solid #F2CB43;
            padding-bottom:10px;
            font-size:21px;
            font-weight: bold;
            color: #c72f6c;
            background-image: url(/special_contents/assets/images/marugame/icon_boat.svg);
            background-position: left center;
            background-repeat: no-repeat;
            padding-left:80px;
             margin-bottom:20px;
              @media screen and (max-width:428px) {
                background-size:46px;
                 padding-left:50px;
                 font-size:14px;
              }
          }
        .link-item{
          font-weight: bold;
          word-break: break-all;
          &::before{
            display:inline-block;
            content:'▶︎';
            margin-right:10px;
            color:#E15F5F
;
          }
        }
      }
   }
}

</style>